import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Typography, Box, Chip, Grid, TextField, Radio, RadioGroup, FormControlLabel } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import { setSelectedProductId } from "store/slice/PharmaSlice";
import { setOrderType } from "store/slice/AppSlice";
import { getCompositiontemplateInfoByTitleAPI } from "api/OmsOrdermgmtWebServices";
import { getListAPI as getProductList } from "components/product/ProductAPI";
import { getProductInfoByPartyidAPI } from "components/product/ProductAPI";
import { setSelectedCTid } from "store/slice/AppSlice";
import {getAPI as getCompositionTemplateObj} from "components/compositiontemplate/CompositiontemplateAPI";
import {setCompositiontemplateList, setSelectedCompositiontemplateId} from "store/slice/PharmaSlice";
import { set } from 'lodash';
import { use } from "react";

export default function SelectCompositionTemplateFromRepeatOrder({ sectionHeight }) {
  const dispatch = useDispatch();
  const { productList } = useSelector((state) => state.pharmaslice);
  const { partyObj } = useSelector((state) => state.pharmaslice.partyDashboard);
  const [filter, setFilter] = useState("");
  const { orderType } = useSelector((state) => state.appslice);
  const { compositiontemplateList } = useSelector((state) => state.pharmaslice);
  const [repeatProductOrder, setRepeatProductOrder] = useState(compositiontemplateList); // renamed
  const { userprofileInfo } = useSelector((state) => state.headerslice);
  const {selectedCTid} = useSelector((state) => state.appslice);
  const [ctIdLocal, setCtIdLocal] = useState(-1);

  useEffect(() => {
      getProductInfoByPartyidAPI(partyObj.id, setRepeatProductOrder, () => {});
  },[]);

  useEffect(() => {
  }, [filter]);

  useEffect(() => {
    if (compositiontemplateList.length > 0) {
      dispatch(setSelectedCompositiontemplateId(ctIdLocal));
    }
  },[compositiontemplateList]);

  const handleProductClick = (productObj) => {
    setCtIdLocal(productObj.ctid);
    dispatch(setSelectedProductId(productObj.id));
    dispatch(setSelectedCTid(productObj.ctid));

    // Need to populate Composition Template Obj as it will be used while editing selected repeat product Order
      getCompositionTemplateObj(productObj.ctid, (data) => {
        const arr = Array.isArray(data) ? data : [data]; // Ensure data is an array as it will be set as Array
        dispatch(setCompositiontemplateList(arr)); 
        
      });
}


  return (

    <Grid container direction="row" justifyContent="center" alignItems="center" sx={{ width: "100%" }}>
      <Grid lg={12} xs={12} item sx={{ padding: 1, backgroundColor: 'white', paddingBottom: 1, display: "flex", justifyContent: "flex-start" }}>
        <Typography variant="h5" sx={{ color: 'primary.darker', fontWeight: 'bold' }}>{orderType === "NEW" ? "Product Composition List " : "Repeat Product List"}</Typography>
      </Grid>
      <Grid lg={12} xs={12} item sx={{ padding: 1, backgroundColor: 'white', paddingBottom: 1, display: "flex", justifyContent: "flex-start", flexDirection: "column" }}>
        <TextField
          label="Filter Product"
          variant="outlined"
          size="small"
          value={filter}
          onChange={e => setFilter(e.target.value)}
          sx={{ width: '100%' }}
          InputProps={{
            startAdornment: (
              <SearchIcon sx={{ color: 'action.active', mr: 1 }} />
            ),
          }}
        />
      </Grid>
      <Grid item lg={12} xs={12} sx={{ display: "flex", alignItems: "center", justifyContent: "flex-start" }}>
        <Box sx={{ backgroundColor: 'white', flex: 1, display: "flex", alignItems: "center", justifyContent: "flex-start", width: "100%" }}>
          <Grid item lg={12} xs={12} sx={{ overflowY: "scroll", backgroundColor: 'white', minHeight: sectionHeight, maxHeight: sectionHeight, }}>
            <Grid container direction="row" justifyContent="center" alignItems="center" sx={{ width: "100%" }}>
              {repeatProductOrder && repeatProductOrder.length > 0 ? (
                [...repeatProductOrder]
                  .filter(productObj => productObj.title.toLowerCase().includes(filter.toLowerCase()))
                  .sort((a, b) => a.title.localeCompare(b.title))
                  .map((productObj) => {
                    return (
                      <Grid
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        item
                        key={productObj.id}
                        sx={{
                          width: '100%',
                          margin: 1,
                          backgroundColor: 'primary.lighter',
                          borderRadius: 1,
                          padding: 1,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-start",
                          border: '2px solid transparent',
                          opacity: 1,
                          transition: 'border-color 0.2s',
                          '&:hover': {
                            borderColor: 'primary.light'
                          },
                        }}
                      >
                        <Radio
                          checked={selectedCTid === productObj.ctid}
                          onChange={() => handleProductClick(productObj)}
                          value={productObj.ctid}
                          color="primary"
                          sx={{ mr: 1 }}
                        />
                        <Typography
                          variant="h6"
                          className="party-title"
                          onClick={() => handleProductClick(productObj)}
                          sx={{
                            cursor: "pointer",
                            wordBreak: "break-word",
                            whiteSpace: "normal",
                            overflowWrap: "break-word",
                            maxWidth: "90hw", // Responsive max width for mobile/tablet/desktop
                            fontSize: { xs: 14, sm: 16 }, // Smaller font on mobile
                          }}
                        >
                          {productObj.title}
                        </Typography>
                      </Grid>
                    );
                  })
              ) : (
                <Box
                  sx={{
                    minWidth: 200,
                    minHeight: 200,
                    backgroundColor: 'secondary.100',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: 2,
                    width: '80%',
                    m: 2

                  }}
                >
                  <Typography variant="h5" color="text.secondary" sx={{}}>
                    {filter === '' ? 'Enter first 3 character of one of the item to few Composition List' : 'Composition not found for the given filter. Please try again.'}
                  </Typography>
                </Box>
              )}
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </Grid>
  );
}